<template lang="pug">
    model-data-table(
        no-data-text='Sin nominas de pago.'
        :no-detail="! $can( 'VIEW_DETAIL_PAYMENT_SHEET' )"
        no-search
        toolbar-dense
        ref="table"
        remind-key='provider-payment-sheet-list'
        v-bind="tableProps"
        @detail="submitUpdate"
        @remove="submitRemove"
    )
</template>

<script>
    //
    import { mapActions, mapState } from "vuex"
    //
    import { ModelDataTable } from "@/components/reusable_components/next"
    import ProviderPaymentSheetModel from "@/models/Purchase/PchProviderPaymentSheet"
    //
    import ProviderPaymentSheetFilters from "@/views/Purchase/PchProviderPaymentSheet/partials/ProviderPaymentSheetFilters"
    import ProviderPaymentSheetHeaders from "@/views/Purchase/PchProviderPaymentSheet/partials/ProviderPaymentSheetHeaders"
    //
    export default {
        name: "provider-payment-sheet-list",
        components: {
            ModelDataTable,
        },
        computed: {

            //
            ...mapState("SnackbarModalModule", {
                responseConfirm: "responseConfirm",
            }),

            /**
             * 
             */
            tableProps () {
                return {
                    filters: ProviderPaymentSheetFilters,
                    headers: ProviderPaymentSheetHeaders,
                    service: ProviderPaymentSheetModel,
                }
            },
        },
        data () {
            return {
                selected: null,
            }
        },
        methods: {

            //
            ...mapActions("MenuesModule", {
                setItemsTopBar: "setItemsTopBar",
                setTitleTopBar: "setTitleTopBar",
            }),

            //
            ...mapActions("SnackbarModalModule", {
                initSnackbar: "initSnackbar",
                hideSnack: "hideSnack",
                resetSnackbarState: "resetSnackbarState",
                setMessageConfirmSnack: "setMessageConfirmSnack",
                setErrorSnackbar: "setErrorSnackbar",
                setSuccessSnackbar: "setSuccessSnackbar",
                setWarningSnackbar: "setWarningSnackbar",
            }),

            //
            canDelete({ pch_provider_payment_sheet_state_id }) {
                return (
                    pch_provider_payment_sheet_state_id < 2 &&
                    this.$can("DELETE_PAYMENT_SHEET")
                )
            },

            /**
             * 
             */
            error ({ response }) {
                this.setErrorSnackbar( response.data.error || response.data.message )
            },
            
            /**
             * 
             */
            refresh () {
                this.$refs.table.refresh()
            },

            /**
             * 
             */
            remove () {
                this.selected.delete().then( this.refresh ).then( this.success ).catch( this.error )
            },
            
            /**
             * 
             */
            showSnackbar(type, title, message) {
                this.initSnackbar(this.fillSnack(type, title, message))
            },

            /**
             *
             */
            submitCreate () {
                this.$router.push({ name: "provider-payment-sheet-create" })
            },

            /**
             * 
             */
            submitRemove ( event ) {
                //
                this.setWarningSnackbar({
                    title: '¿Desea eliminar la nómina de pago?',
                    confirm: 'eliminar',
                })

                //
                this.selected = event.item
            },

            /**
             * 
             */
            submitUpdate ( event ) {
                this.$router.push( "/provider_payment_sheet/" + event.item.id )
            },

            /**
             * 
             */
            success () {
                this.setSuccessSnackbar( "Nómina de pago eliminada." )
            }
        },
        mounted() {
            this.setItemsTopBar([
                {
                    text: "crear nomina de pago",
                    icon: "add_circle",
                    action: this.submitCreate,
                }
            ])
            this.setTitleTopBar( "Nóminas de pago" )
        },
        watch: {

            /**
             * 
             */
            responseConfirm ( val ) {
                switch ( val ) {
                    case "eliminar": this.remove(); break;
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can("VIEW_ALL_PAYMENT_SHEET")) ctx.$router.push("/")
            })
        },
    }
</script>
